export class ProductChange {
    planName: string;
    planFullName: string;
    planValue: number;
    consumedValue: number;
    currentPlan: boolean;
    expirationDate: string;
    maxInstallment: number;
    maxInstallmentValue: number;
    planIdentifier: string;
    featureList: Array<any>;
    footerText: Array<String>;

    constructor(planData: any) {
        
        this.planName = planData.product.name;
        this.planValue = planData.value;
        this.consumedValue = planData.consumedValue;
        this.currentPlan = planData.currentPlan;
        this.expirationDate = planData.planExpirationDate;
        this.maxInstallment = planData.maxInstallment;
        this.maxInstallmentValue = planData.maxInstallmentValue;
        this.planIdentifier = planData.product.identifier;
        this.featureList = planData.featureList;
        this.footerText = planData.footerContent;
    }
}